var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarWashColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6297 8.38101C18.2526 7.76423 17.5916 7.39648 16.8666 7.39648H7.13421C6.41036 7.39648 5.74821 7.76423 5.37113 8.38101L2.78878 12.5727C2.58978 12.8997 2.48273 13.2756 2.48273 13.6573V19.397C2.48273 20.0813 3.039 20.6387 3.72445 20.6387H5.79358C6.47787 20.6387 7.03531 20.0825 7.03531 19.397V18.9827H16.9655V19.397C16.9655 20.0813 17.5218 20.6387 18.2072 20.6387H20.2764C20.9607 20.6387 21.5181 20.0825 21.5181 19.397V13.6573C21.5181 13.2768 21.411 12.8997 21.212 12.5727L18.6297 8.38101ZM19.8632 14.8432C19.8632 15.0713 19.677 15.2574 19.449 15.2574H18.2072C17.7895 15.2574 17.3833 15.4274 17.0854 15.7206L17.0156 15.7904C16.7177 16.093 16.5524 16.4899 16.5524 16.9123C16.5524 17.1404 16.3662 17.3266 16.1381 17.3266C15.91 17.3266 15.7238 17.1404 15.7238 16.9123C15.7238 16.2664 15.9764 15.6624 16.4314 15.2074L16.5012 15.1376C16.9481 14.686 17.573 14.43 18.2061 14.43H19.4478C19.6759 14.43 19.8621 14.6162 19.8621 14.8443L19.8632 14.8432ZM19.0347 11.9478C19.0347 12.1758 18.8485 12.362 18.6204 12.362H16.1381C15.91 12.362 15.7239 12.1758 15.7239 11.9478C15.7239 11.7197 15.9101 11.5335 16.1381 11.5335H18.6204C18.8485 11.5335 19.0347 11.7197 19.0347 11.9478ZM15.3107 11.9478C15.3107 12.1758 15.1245 12.362 14.8964 12.362H5.37942C5.15132 12.362 4.96513 12.1758 4.96513 11.9478C4.96513 11.7197 5.15133 11.5335 5.37942 11.5335H14.8964C15.1245 11.5335 15.3107 11.7197 15.3107 11.9478ZM9.10447 16.499C8.87637 16.499 8.69018 16.3129 8.69018 16.0848C8.69018 15.8567 8.87638 15.6705 9.10447 15.6705H14.8975C15.1256 15.6705 15.3118 15.8567 15.3118 16.0848C15.3118 16.3129 15.1256 16.499 14.8975 16.499H9.10447ZM13.2428 17.3265C13.2428 17.5546 13.0567 17.7407 12.8286 17.7407H11.1737C10.9456 17.7407 10.7594 17.5545 10.7594 17.3265C10.7594 17.0984 10.9456 16.9122 11.1737 16.9122H12.8286C13.0567 16.9122 13.2428 17.0984 13.2428 17.3265ZM8.27715 16.9122C8.27715 17.1403 8.09095 17.3265 7.86286 17.3265C7.63478 17.3265 7.44858 17.1403 7.44858 16.9122C7.44858 16.4897 7.28333 16.0929 6.9854 15.7903L6.91558 15.7205C6.61766 15.4272 6.21267 15.2573 5.79374 15.2573H4.55202C4.32392 15.2573 4.13773 15.0711 4.13773 14.843C4.13773 14.615 4.32393 14.4288 4.55202 14.4288H5.79374C6.42682 14.4288 7.05176 14.6848 7.49864 15.1363L7.56846 15.2061C8.02347 15.6612 8.27602 16.2652 8.27602 16.911L8.27715 16.9122ZM6.20802 19.3956C6.20802 19.6237 6.02298 19.8099 5.79373 19.8099H3.7246C3.49651 19.8099 3.31031 19.6237 3.31031 19.3956V18.5682C3.65361 18.8289 4.08422 18.9825 4.55204 18.9825H6.20688V19.3968L6.20802 19.3956ZM20.6907 19.3956C20.6907 19.6237 20.5057 19.8099 20.2764 19.8099H18.2073C17.9792 19.8099 17.793 19.6237 17.793 19.3956V18.9813H19.4479C19.9157 18.9813 20.3463 18.8277 20.6896 18.567V19.3944L20.6907 19.3956Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 11.5336C24.0002 10.8493 23.4439 10.2919 22.7585 10.2919H21.1036C20.8744 10.2919 20.6893 10.4769 20.6893 10.7062C20.6893 10.9342 20.8744 11.1204 21.1036 11.1204H22.7585C22.9866 11.1204 23.1727 11.3066 23.1727 11.5347C23.1727 11.7628 22.9877 11.949 22.7585 11.949H22.3442C22.1149 11.949 21.9299 12.134 21.9299 12.3633C21.9299 12.5914 22.1149 12.7776 22.3442 12.7776H22.7585C23.4428 12.7776 24.0002 12.2213 24.0002 11.5359V11.5336Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65601 11.948H1.24172C1.01363 11.948 0.827438 11.7618 0.827438 11.5337C0.827438 11.3057 1.01247 11.1195 1.24172 11.1195H2.89657C3.12583 11.1195 3.31085 10.9344 3.31085 10.7052C3.31085 10.4771 3.12582 10.2909 2.89657 10.2909H1.24172C0.557435 10.2909 0 10.8472 0 11.5326C0 12.2169 0.556273 12.7743 1.24172 12.7743H1.65601C1.88527 12.7743 2.07029 12.5893 2.07029 12.3601C2.07029 12.132 1.88526 11.9458 1.65601 11.9458V11.948Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.69 5.32672C20.69 5.55481 20.8762 5.741 21.1043 5.741C21.3324 5.741 21.5186 5.5548 21.5186 5.32672C21.5186 4.41202 22.0772 3.67187 22.7603 3.67187C22.9884 3.67187 23.1746 3.48567 23.1746 3.25759C23.1746 3.0295 22.9884 2.8433 22.7603 2.8433C22.0772 2.8433 21.5186 2.10315 21.5186 1.18845C21.5186 0.960362 21.3324 0.77417 21.1043 0.77417C20.8762 0.77417 20.69 0.960368 20.69 1.18845C20.69 2.10315 20.1314 2.8433 19.4483 2.8433C19.2202 2.8433 19.034 3.0295 19.034 3.25759C19.034 3.48567 19.2202 3.67187 19.4483 3.67187C20.1314 3.67187 20.69 4.41202 20.69 5.32672Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07019 8.22369C2.07019 8.45178 2.25639 8.63798 2.48448 8.63798C2.71256 8.63798 2.89876 8.45178 2.89876 8.22369C2.89876 7.30899 3.45736 6.56884 4.14049 6.56884C4.36858 6.56884 4.55477 6.38265 4.55477 6.15456C4.55477 5.92647 4.36857 5.74027 4.14049 5.74027C3.45736 5.74027 2.89876 5.00013 2.89876 4.08543C2.89876 3.85734 2.71256 3.67114 2.48448 3.67114C2.25639 3.67114 2.07019 3.85734 2.07019 4.08543C2.07019 5.00013 1.5116 5.74027 0.82847 5.74027C0.600378 5.74027 0.414185 5.92647 0.414185 6.15456C0.414185 6.38266 0.600384 6.56884 0.82847 6.56884C1.5116 6.56884 2.07019 7.30899 2.07019 8.22369Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44932 0.36145C7.22006 0.36145 7.03503 0.546484 7.03503 0.775735V1.19002C7.03503 1.41811 7.22007 1.60431 7.44932 1.60431C7.67858 1.60431 7.8636 1.41927 7.8636 1.19002V0.775735C7.8636 0.547643 7.67857 0.36145 7.44932 0.36145Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03503 3.2585C7.03503 3.48659 7.22007 3.67279 7.44932 3.67279C7.67858 3.67279 7.8636 3.48775 7.8636 3.2585V2.84422C7.8636 2.61613 7.67857 2.42993 7.44932 2.42993C7.22006 2.42993 7.03503 2.61497 7.03503 2.84422V3.2585Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27671 2.43062H8.691C8.92025 2.43062 9.10528 2.24559 9.10528 2.01634C9.10528 1.78824 8.92025 1.60205 8.691 1.60205H8.27671C8.04745 1.60205 7.86243 1.78708 7.86243 2.01634C7.86243 2.24443 8.04746 2.43062 8.27671 2.43062Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62197 1.60303H6.20768C5.97842 1.60303 5.7934 1.78806 5.7934 2.01731C5.7934 2.2454 5.97843 2.4316 6.20768 2.4316H6.62197C6.85122 2.4316 7.03625 2.24656 7.03625 2.01731C7.03625 1.78922 6.85122 1.60303 6.62197 1.60303Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3102 3.25842C15.081 3.25842 14.8959 3.44346 14.8959 3.67271V4.08699C14.8959 4.31509 15.081 4.50128 15.3102 4.50128C15.5395 4.50128 15.7245 4.31624 15.7245 4.08699V3.67271C15.7245 3.44462 15.5395 3.25842 15.3102 3.25842Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8974 6.1545C14.8974 6.38259 15.0824 6.56878 15.3117 6.56878C15.5409 6.56878 15.726 6.38375 15.726 6.1545V5.74021C15.726 5.51212 15.5409 5.32593 15.3117 5.32593C15.0824 5.32593 14.8974 5.51096 14.8974 5.74021V6.1545Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1391 5.32711H16.5534C16.7827 5.32711 16.9677 5.14207 16.9677 4.91282C16.9677 4.68473 16.7827 4.49854 16.5534 4.49854H16.1391C15.9099 4.49854 15.7249 4.68357 15.7249 4.91282C15.7249 5.14091 15.9099 5.32711 16.1391 5.32711Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4829 4.5H14.0686C13.8393 4.5 13.6543 4.68503 13.6543 4.91429C13.6543 5.14238 13.8393 5.32857 14.0686 5.32857H14.4829C14.7121 5.32857 14.8972 5.14354 14.8972 4.91429C14.8972 4.68619 14.7121 4.5 14.4829 4.5Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_847_25425",
    x1: 12.0004,
    y1: 7.39648,
    x2: 12.0004,
    y2: 20.6387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_847_25425",
    x1: 22.3448,
    y1: 10.2919,
    x2: 22.3448,
    y2: 12.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_847_25425",
    x1: 1.65543,
    y1: 10.2909,
    x2: 1.65543,
    y2: 12.7743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_847_25425",
    x1: 21.1043,
    y1: 0.77417,
    x2: 21.1043,
    y2: 5.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_847_25425",
    x1: 2.48448,
    y1: 3.67114,
    x2: 2.48448,
    y2: 8.63798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_847_25425",
    x1: 7.44932,
    y1: 0.36145,
    x2: 7.44932,
    y2: 1.60431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_847_25425",
    x1: 7.44932,
    y1: 2.42993,
    x2: 7.44932,
    y2: 3.67279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_847_25425",
    x1: 8.48385,
    y1: 1.60205,
    x2: 8.48385,
    y2: 2.43062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_847_25425",
    x1: 6.41482,
    y1: 1.60303,
    x2: 6.41482,
    y2: 2.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_847_25425",
    x1: 15.3102,
    y1: 3.25842,
    x2: 15.3102,
    y2: 4.50128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_847_25425",
    x1: 15.3117,
    y1: 5.32593,
    x2: 15.3117,
    y2: 6.56878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_847_25425",
    x1: 16.3463,
    y1: 4.49854,
    x2: 16.3463,
    y2: 5.32711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_847_25425",
    x1: 14.2757,
    y1: 4.5,
    x2: 14.2757,
    y2: 5.32857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWashColorIcon);
export default __webpack_public_path__ + "static/media/car-wash-color-icon.7969b105eee56af5577e274d513d7e77.svg";
export { ForwardRef as ReactComponent };